import { $authHost } from '.'
import { SearchResult } from '../helpers/types/search'

export const searchAll = async (query: string, type: string) => {
	const { data } = await $authHost.post('/search', {
		s: query,
		type
	})
	return data as SearchResult
}
